<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{ on, attrs }">
        <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="mudarEstadoDialog">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Detalhamento das últimas compras</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-white px-2" style="background: #042333;">
          <v-btn icon dark class="mr-5">
            <v-icon @click.stop="mudarEstadoDialog">mdi-close</v-icon>
          </v-btn>

          <span>Últimas compras</span>
        </v-card-title>

        <v-card-text class="py-0 pt-4 px-2">
          <v-data-table
            v-model="compras_selecionadas"
            item-key="index"
            height="calc(100vh - 170px)"
            :headers="headers"
            :items="items"
            class="table-full-screen"
            :items-per-page="-1"
            fixed-header
            show-select
          >
            <template v-slot:top>
              <div class="d-flex align-center">
                <slot name="topo-tabela.prepend" />

                <DesconsiderarPedidoEmTransito
                  v-if="compras_selecionadas.filter(item => item.qtde_pendente > 0 || item.pedido_desconsiderado).length > 0"
                  :pedidos="compras_selecionadas.filter(item => item.qtde_pendente > 0 || item.pedido_desconsiderado)"
                  habilitar_botao_grande
                  tela_compra_materia_prima
                  :idgrupo="Number(GRUPO_COMPRA_COMPUTED)"
                  @update:desconsiderar-pedido-em-transito="updatePedidoEmTransitoDesconsiderado"
                />
              </div>
            </template>

            <template #item.data-table-select="{item, select, isSelected}">
              <v-btn v-if="item.qtde_pendente > 0 || item.pedido_desconsiderado" icon @click="select(!isSelected)">
                <v-icon v-if="isSelected">mdi-checkbox-marked</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </v-btn>

              <v-btn v-else icon disabled>
                <v-icon>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </template>

            <template #item.razao_social="{item}">
              {{ item.fornecedor }}
            </template>

            <template #item.qtde="{item}">
              {{ Helpers.formatarValor(item.qtde) }}
            </template>

            <template #item.qtde_pendente="{item}">
              {{ Helpers.formatarValor(item.qtde_pendente) }}
            </template>

            <template #item.preco_unitario="{item}">
              {{ Helpers.formatarValorMonetario(item.preco_unitario) }}
            </template>

            <template #item.total_compra="{item}">
              {{ Helpers.formatarValorMonetario(item.total_compra) }}
            </template>

            <template #item.preco_unitario_anterior="{item}">
              {{ Helpers.formatarValorMonetario(item.preco_unitario_anterior) }}
            </template>

            <template #item.indicador_preco="{item}">
              <div :title="Helpers.formatarValorPercent(item.indicador_preco)">
                <v-icon v-if="parseFloat(item.indicador_preco) > 0" color="red darken-2">mdi-arrow-up</v-icon>
                <v-icon v-else-if="parseFloat(item.indicador_preco) < 0" color="green darken-2">mdi-arrow-down</v-icon>
              </div>
            </template>

            <template #item.tempo_entrega="{item}">
              <div v-if="parseInt(item.atraso) < 0" class="text-green">
                {{ Math.abs(item.atraso) }} {{ Math.abs(item.atraso) > 1 ? 'dias' : 'dia'}}
              </div>
              <div v-if="parseInt(item.atraso) === 0">
                {{ Math.abs(item.tempo_entrega) }} {{ Math.abs(item.tempo_entrega) > 1 ? 'dias' : 'dia'}}
              </div>
              <div v-if="parseInt(item.atraso) > 0" class="text-red">
                atraso de {{ item.atraso }} {{ item.atraso > 1 ? 'dias' : 'dia'}}
              </div>
            </template>

            <template #item.acoes="{ item }">
              <DesconsiderarPedidoEmTransito
                v-if="item.qtde_pendente > 0 || item.pedido_desconsiderado"
                :idgrupo="item.id_grupo"
                :pedidos="[item]"
                tela_compra_materia_prima
                @update:desconsiderar-pedido-em-transito="updatePedidoEmTransitoDesconsiderado"
              />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequisicaoAPI from "@/api/Requisicao";
import { logout } from "@/helpers";
import DesconsiderarPedidoEmTransito from "@/components/produto/detalhes/UltimasCompras/DesconsiderarPedidoEmTransito.vue";
import {mapGetters} from "vuex";

export default {
  name: "UltimasCompras",
  components: {
    DesconsiderarPedidoEmTransito
  },
  props: {
    filtros: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:desconsiderar-pedido-em-transito'],
  data: () => ({
    dialog_ativo: false,
    headers: [
      {text: 'Produto', value: 'produto'},
      { text: "Filial", value: "filial" },
      { text: "Pedido", value: "ordem_compra" },
      { text: "Razão Social", value: "razao_social" },
      { text: "Dt. Solicitação", value: "data_solicitacao" },
      { text: "Dt. Previsão", value: "data_previsao" },
      { text: "Dt. Entrada", value: "data_entrega" },
      { text: "Dt. Faturamento", value: "data_faturamento" },
      {text: "UND", value: "unidade_compra"},
      { text: "Qtde.", value: "qtde" },
      { text: "Qtde. Pendente", value: "qtde_pendente" },
      { text: "Valor Unit.", value: "preco_unitario" },
      { text: "Valor Unitário Anterior", value: "preco_unitario_anterior" },
      { text: "Indicador", value: "indicador_preco" },
      { text: "Total", value: "total_compra" },
      { text: "Tempo entrega", value: "tempo_entrega" },
      { text: "Ações", value: "acoes" },
    ],
    items: [],
    compras_selecionadas: [],
  }),
  computed: {
    ...mapGetters({
      'GRUPO_COMPRA_COMPUTED': 'usuario/getGrupoCompras',
      'callbackAtualizarGridCategorias': 'compraMateriaPrima/callbackAtualizarGridCategorias',
      'callbackAtualizarCardsTotais': 'compraMateriaPrima/callbackAtualizarCardsTotais',
    }),
  },
  methods: {
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;

      if (this.dialog_ativo) {
        this.items = [];
        this.getPedidosEmAberto();
      }
    },
    getPedidosEmAberto() {
      const parametros = {
        id_grupo: this.filtros.grupo,
        id_categoria: this.filtros.idcategoria
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        RequisicaoAPI.buscarUltimasComprasCategoriaMateriaPrima(parametros)
          .then(resp => {
            const {token, compras} = resp.data
            localStorage.token = token
            this.items = compras;
          })
          .catch(logout)
      );
    },
    updatePedidoEmTransitoDesconsiderado() {
      this.getPedidosEmAberto();
      this.compras_selecionadas = [];
      this.callbackAtualizarGridCategorias();
      this.callbackAtualizarCardsTotais();
      this.$emit('update:desconsiderar-pedido-em-transito', {});
    }
  }
}
</script>

<style scoped>

</style>
